var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var needToSetLineBreak = function (skillName) {
    return /(\d+)$/.test(skillName);
};
export var processSkillName = function (skill) {
    if (needToSetLineBreak(skill.name)) {
        return __assign(__assign({}, skill), { name: skill.name.replace(/^(.*?)\s(\d+)$/, '$1\u00A0$2') });
    }
    return skill;
};
